import * as React from 'react'

import { MarketOrder } from 'api/inventory'
import { useMarketOrders } from 'hooks/useInventory'
import { formatWeightAsGrams } from 'utils/formatWeightAsGrams'

/** styles */
import useStyles from './styles'
import {
  API_DATE_FORMAT,
  formatDate,
  UI_DATE_FORMAT,
  roundUpDollarsAndCents,
  roundDownDollarsAndCents
} from 'utils/util'
import { TableBaseProps } from './TableBase/models'
import TableBase from './TableBase'

interface Props {
  productId: string
}

export default function TableTransactionHistory({ productId }: Props) {
  const { classes } = useStyles()

  const { data: marketOrdersData } = useMarketOrders(
    productId ? Number(productId) : 0
  )

  const tableRows = React.useRef<TableBaseProps<MarketOrder>['rows']>([
    {
      id: 'date',
      label: 'DATE',
      render: data =>
        formatDate({
          date: data?.createdAt,
          inputFormat: API_DATE_FORMAT,
          outputFormat: UI_DATE_FORMAT
        }) || ''
    },
    {
      id: 'buy_price',
      label: 'BUY PRICE',
      render: data => {
        if (data.orderType === 'buy') {
          return roundUpDollarsAndCents(
            Number(data.pricePerUnit) * data.quantityMg
          )
        } else {
          return ''
        }
      }
    },
    {
      id: 'sell_price',
      label: 'SELL PRICE',
      render: data => {
        if (data.orderType === 'sell') {
          return roundDownDollarsAndCents(
            Number(data.pricePerUnit) * data.quantityMg
          )
        } else {
          return ''
        }
      }
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      render: data =>
        data?.quantityMg ? formatWeightAsGrams(data.quantityMg) : ''
    }
  ]).current

  const marketOrdersForProduct = productId ? marketOrdersData : undefined

  if (!marketOrdersForProduct || marketOrdersForProduct?.length < 1) {
    return <></>
  }

  const sortedOrders = [...marketOrdersForProduct].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )

  return (
    <TableBase
      className={classes.tableTransition}
      rows={tableRows}
      data={sortedOrders}
    />
  )
}
